<template>
  <div
    class="detail"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <BaseInfoForm
            :contractStatus="contractStatus"
            ref="baseInfoFormRef"
            :fetchData="formData"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            合同信息
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs v-model="tabName" type="card">
            <el-tab-pane label="合同行信息" name="contract">
              <el-collapse v-model="activeContractNames" class="collapse-main-content">
                <el-collapse-item name="1">
                  <template slot="title">
                    <div class="collapse-title-pre">
                      <span></span>
                      空间行信息
                    </div>
                  </template>
                  <div class="collapse-content">
                    <SpaceRowTable
                      :contractStatus="contractStatus"
                      ref="spaceLinesRef"
                      :fetchTableData="spacesList"
                    />
                  </div>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template slot="title">
                    <div class="collapse-title-pre">
                      <span></span>
                      其他费用行信息
                    </div>
                  </template>
                  <div class="collapse-content">
                    <ExpenseRowTable
                      :contractStatus="contractStatus"
                      ref="expenseLinesRef"
                      :fetchTableData="expensesList"
                    />
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
            <template v-if="currentStatus != 'create'">
              <!-- <el-tab-pane label="关联合同信息" name="connectedContract">
                <RelationContractTable
                  ref="relationContractInfoRef"
                  :fetchTableData="relatedList"
                />
              </el-tab-pane> -->
              <el-tab-pane label="历史执行情况" name="historyExecute">
                <el-collapse v-model="historyExecuteActiveNames" class="collapse-main-content">
                  <el-collapse-item name="1">
                    <template slot="title">
                      <div class="collapse-title-pre">
                        <span></span>
                        付款信息
                      </div>
                    </template>
                    <div class="collapse-content">
                      <HistoryExecuteTable
                        ref="historyExecuteTableRef"
                        :fetchTableData="paymentTotal"
                      />
                    </div>
                  </el-collapse-item>
                  <el-collapse-item name="2">
                    <template slot="title">
                      <div class="collapse-title-pre">
                        <span></span>
                        发票信息
                      </div>
                    </template>
                    <div class="collapse-content">
                      <InvoiceInformationExpandTable
                        ref="invoiceInformationExpandTableRef"
                        :fetchTableData="invoiceTotal"
                      />
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane label="审批记录" name="approvalRecord">
                <ApprovalRecordTable ref="approvalRecordRef" :fetchTableData="approvalList" />
              </el-tab-pane>
              <el-tab-pane label="变更记录" name="changeRecord">
                <ChangeRecordTable ref="changeRecordRef" :fetchTableData="changeList" />
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable ref="fileTableRef" :attachments="attachments" :isShowDownBtn="isShowDownBtn" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮组合 -->
    <FooterBtnGroup @btnHandler="btnGroupHandler" :contractStatus="contractStatus" />
    <!-- 关闭合同弹框 -->
    <CloseContractDialog ref="closeContractDialogRef" @refreshTable="closeContractHandler" />
    <!-- 审批弹框 -->
    <ApprovalDialog ref="approvalDialogRef" @refreshTable="closeDialogHandler" />
  </div>
</template>

<script>
  import BaseInfoForm from './components/BaseInfoForm/index.vue';
  import SpaceRowTable from './components/SpaceRowTable/index.vue';
  import ExpenseRowTable from './components/ExpenseRowTable/index.vue';
  import HistoryExecuteTable from './components/HistoryExecuteTable/index.vue';
  import InvoiceInformationExpandTable from './components/InvoiceInformationExpandTable/index.vue';
  import ApprovalRecordTable from './components/ApprovalRecordTable/index.vue';
  import ChangeRecordTable from './components/ChangeRecordTable/index.vue';
  import FooterBtnGroup from './components/FooterBtnGroup/index.vue';
  import btnGroupMixin from './btnGroupMixin';
  import CloseContractDialog from './../components/CloseContractDialog/index.vue';
  import leaseContractApi from '@/api/park/leaseContract';
  import ApprovalDialog from './../components/ApprovalDialog/index.vue';
  // import RelationContractTable from './components/RelationContractTable/index.vue';
  export default {
    name: 'leaseDetail',
    mixins: [btnGroupMixin],
    data() {
      return {
        activeNames: ['1', '2', '3', '4'],
        contractStatus: '', // 后端单据状态
        currentStatus: 'create', // 前端定义的状态

        isLoading: false,
        storageList: [],
        settlementList: [],
        tabName: 'contract',
        activeContractNames: ['1', '2'],
        historyExecuteActiveNames: ['1', '2'],
        formData: {},
        attachments: [],
        approvalList: [],
        changeList: [],
        spacesList: [],
        expensesList: [],
        relatedList: [],
        invoiceTotal: {},
        paymentTotal: {},
        changeRowData: null,
      };
    },
    computed: {
      isShowDownBtn() {
        const currentStatus = this.$route.query.status;
        if (['editAgreement', 'renew', 'change', 'create'].includes(currentStatus)) {
          return false;
        } else {
          return ['02', '03', '05', '06'].includes(this.contractStatus);
        }
      },
    },
    mounted() {
      this.currentStatus = this.$route.query?.status;
      const id = this.$route.query?.id;
      if (id) {
        this.initPageData(id);
      }
    },
    methods: {
      // 跳转到列表页面
      closeDialogHandler() {
        this.cancelHandler();
      },
      // 根据id获取详情页面数据
      async initPageData(id) {
        console.log(id);
        const { data } = await this.$axios.post(`${leaseContractApi.GET_DETAIL_DATA_BY_ID}/${id}`);
        if (data.code == 0) {
          const {
            spacesList,
            expensesList,
            changeList,
            approvalList,
            paymentTotal,
            invoiceTotal,
            attachments,
            relatedList,
            ...formData
          } = data.data;
          this.spacesList = spacesList;
          this.expensesList = expensesList;
          this.changeList = changeList;
          this.approvalList = approvalList;
          this.paymentTotal = paymentTotal;
          this.relatedList = relatedList;
          this.invoiceTotal = invoiceTotal;
          this.attachments = attachments;
          this.formData = formData;
          this.contractStatus = formData.contractStatus;
          if (this.$route.query?.status == 'renew') {
            this.formData = {
              ...this.formData,
              superviseContractNo: this.$route.query?.contractNo,
            };
            console.log('this.formData.superviseContractNo', this.formData.superviseContractNo);
          }
        } else {
          this.$message.error('获取详情数据失败');
        }
      },
      closeContractHandler() {
        // 判断当前是否为变更主体的时候
        if (this.changeRowData) {
          // 路由直接跳转
          const path = {
            path: '/park/leaseContract/leaseDetail',
            name: 'leaseDetail',
            meta: {
              keepAlive: false,
              title: '三方仓库租赁合同维护',
            },
            query: {
              status: 'change',
              id: this.changeRowData.id,
            },
          };
          this.changeRowData = null;
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        }
      },
    },
    components: {
      BaseInfoForm,
      SpaceRowTable,
      ExpenseRowTable,
      HistoryExecuteTable,
      InvoiceInformationExpandTable,
      ApprovalRecordTable,
      ChangeRecordTable,
      FooterBtnGroup,
      CloseContractDialog,
      ApprovalDialog,
      // RelationContractTable,
    },
  };
</script>

<style lang="scss" scoped></style>
